import { FunctionComponent } from 'react'
import { Box } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import useAuthStore from '../../stores/auth'
import colors from '../../colors'
import { SPACING } from '../../constants'
import PlatformFeesSection from './PlatformFeesSection'
import OrganizationsSection from './OrganizationsSection'
import SmsRegistrationsSection from './SmsRegistrationsSection'

/**
 * Stitch's own tooling, not a brewery's. Super admins only - the nav hides it
 * for everyone else and each underlying endpoint refuses non-super-admins, so
 * this guard is the third layer rather than the only one.
 *
 * Add future internal tools as further sections here.
 */
const StitchDashboard: FunctionComponent = () => {
  const styles = useStyles()
  const user = useAuthStore((state) => state.user)

  if (user?.role !== 'super_admin') return null

  return (
    <Box className={styles.container}>
      <Box className={styles.header}>
        <h1 className={styles.title}>Stitch Dashboard</h1>
        <p className={styles.subtitle}>
          Internal tools. Nothing here is visible to organisations.
        </p>
      </Box>

      <Box className={styles.sections}>
        <OrganizationsSection />
        <SmsRegistrationsSection />
        <PlatformFeesSection />
      </Box>
    </Box>
  )
}

const useStyles = makeStyles({
  container: {
    padding: SPACING * 2,
  },
  header: {
    marginBottom: SPACING * 3,
  },
  title: {
    margin: 0,
    fontSize: 26,
    fontWeight: 700,
    color: colors.STITCH_BLACK,
  },
  subtitle: {
    margin: `${SPACING}px 0 0`,
    fontSize: 14,
    color: colors.GREY_2,
  },
  sections: {
    display: 'flex',
    flexDirection: 'column',
    gap: SPACING * 3,
  },
})

export default StitchDashboard
